import React from "react";

function SvgIcMapSearch(props) {
  return (
    <svg viewBox="4 0 16 16" width="1em" height="1em" {...props}>
      <path
        d="M10.5 0a6.5 6.5 0 015.022 10.627l.54.54c.409-.126.868-.05 1.22.227l.117.105 2.206 2.205c.525.524.527 1.373.005 1.9a1.335 1.335 0 01-1.779.106l-.113-.101-2.207-2.205a1.346 1.346 0 01-.34-1.33l-.548-.549A6.5 6.5 0 1110.5 0zm-.018 1.924a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"
        fill="#666"
      />
    </svg>
  );
}

export default SvgIcMapSearch;
